import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        isLoading: true,
        halls: [],
        cookiesTypes: null,
        mask: false,
        // extraPersons: [ { id: 0 } ],
        // deliveries: [ { id: 0 } ],
        // businessAddress: null,
        // businessProfileSymbol: null
    },
    mutations: {
        /**
         *
         * @param {object} state
         * @param {boolean} loading
         */
        setLoading(state, loading) {
            state.isLoading = loading
        },
        /**
         *
         * @param {object} state
         * @param {array} halls
         */
        setHalls(state, halls) {
            state.halls = halls
        },
        /**
         *
         * @param {object} state
         * @param {object} cookiesTypes
         */
        setCookiesTypes(state, cookiesTypes) {
            state.cookiesTypes = cookiesTypes
        },
        /**
         *
         * @param {object} state
         * @param {boolean} mask
         */
        setMask(state, mask) {
            state.mask = mask
        }

        // addExtraPerson (state, data) {
        //     state.extraPersons.push(data)
        // },
        // updateExtraPerson (state, payload) {
        //     Vue.set(state.extraPersons, payload.index, payload.data)
        // },
        // removeExtraPerson (state, index) {
        //     state.extraPersons.splice(index, 1)
        // },
        // addDelivery (state, data) {
        //     state.deliveries.push(data)
        // },
        // updateDelivery (state, payload) {
        //     Vue.set(state.deliveries, payload.index, payload.data)
        // },
        // removeDelivery (state, index) {
        //     state.deliveries.splice(index, 1)
        // },
        // setBusinessAddress (state, data) {
        //     state.businessAddress = data
        // },
        // setBusinessProfileSymbol (state, data) {
        //     state.businessProfileSymbol = data
        // }
    },

    getters: {
        getCookiesTypes: state => state.cookiesTypes,
        isMask: state => state.mask,
    }
})
